import { Placeholder } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { formatDate } from 'services/utils';
import './BalancesDocumentsTableRowContent.scss';

const BalancesDocumentsTableRowContent = ({ isLoading, balancesDocumentData, handleDownloadBalancesDocumentById }) => {
  const getBalancesDocumentInfoBlock = (balancesDocumentBlockInfo, callBack) => {
    if (isLoading) {
      return (
        <Placeholder as={'p'} animation={'glow'}>
          <Placeholder className={'balances-document-loader-placeholder'} xs={12} bg={'secondary'} />
        </Placeholder>
      );
    } else if (callBack) {
      return (
        // eslint-disable-next-line
        <p className={'balances-document-table-cell-info-link'} onClick={callBack}>
          {balancesDocumentBlockInfo}
        </p>
      );
    } else {
      return <p>{balancesDocumentBlockInfo}</p>;
    }
  };

  return (
    <tr>
      <td className={'balances-document-table-cell'}>
        {getBalancesDocumentInfoBlock(balancesDocumentData.documentId)}
      </td>
      <td className={'balances-document-table-cell'}>
        {getBalancesDocumentInfoBlock(balancesDocumentData.name, () =>
          handleDownloadBalancesDocumentById(balancesDocumentData.documentId)
        )}
      </td>
      <td className={'balances-document-table-cell'}>{getBalancesDocumentInfoBlock(balancesDocumentData.type)}</td>
      <td className={'balances-document-table-cell'}>
        {getBalancesDocumentInfoBlock(formatDate(balancesDocumentData.createdAt))}
      </td>
    </tr>
  );
};

BalancesDocumentsTableRowContent.propTypes = {
  isLoading: PropTypes.bool,
  balancesDocumentData: PropTypes.oneOfType([
    PropTypes.shape({
      createdAt: PropTypes.string,
      documentId: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.string
    }),
    PropTypes.oneOf([null])
  ]),
  handleDownloadBalancesDocumentById: PropTypes.func
};

export default BalancesDocumentsTableRowContent;
